/* unplugin-vue-components disabled */import script from "./auto-hide-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./auto-hide-bar.vue?vue&type=script&setup=true&lang=js"

import "./auto-hide-bar.vue?vue&type=style&index=0&id=03478ac0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03478ac0"]])

export default __exports__